import React from "react";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("AdminToken");

  if (token) {
    return <Navigate to="/" replace />; // redirect to dashboard/home
  }

  return children;
};

export default PublicRoute;